//@ts-nocheck
import { Component, Prop } from 'vue-property-decorator';
import Template from "./template.vue";
import { FiltrosType } from '../../store/modules/general/types';
import FormsMixin from '../../mixins/FormsMixin';
import { ARTICULO, CESTA } from '@/store/modules/ventas/types';
import { Mutation, State, Action } from 'vuex-class';

@Component({
  mixins: [Template],
})
export default class Header extends FormsMixin {
  @Action("checkArticuloPermitido", { namespace: "general" }) CheckArticuloPermitido!: Function;
  @Action("GetImageUrl", { namespace: "general" }) GetImageUrl!: Function;
  @Prop({ required: false }) verFiltros!: boolean;
  @Prop({ required: false }) proveedores!: Array<string>;
  @Prop({ required: false }) situaciones!: Array<string>;
  @Prop({ required: false }) mostrarBotones!: boolean;
  @Prop({ required: false }) mostrarVenta!: boolean;
  @Mutation("unsetUsuario", { namespace: "auth" }) unsetUsuario!: Function;
  @Prop({ required: false, default: "" }) tituloParam!: string;
  @Prop({ required: false, default: false }) VolverInicio!: boolean;
  @State('isMobile') isMobile!: boolean;
  @Action("checkStock", { namespace: "ventas" }) checkStock!: Function;
  


  public titulo = "";
  public showCart = false;
  public showClose = false;
  public cesta: Array<CESTA> = [];
  public search = "";
  public proveedor = "";
  public situacion = "";
  public dialogFiltros = false;
  public dates: Array<string> = [];
  public menuDate = false;
  public imageUrl = "";
  public breadcrum: Array<{ text: string; disabled: boolean; href: string }> = [
    {
      text: 'Dashboard',
      disabled: false,
      href: 'breadcrumbs_dashboard',
    },
    {
      text: 'Compras',
      disabled: false,
      href: 'breadcrumbs_dashboard',
    },
    {
      text: 'Listado',
      disabled: true,
      href: 'breadcrumbs_dashboard',
    },
  ];

  public items: Array<{ title: string}> = [
    {
      title: "Prueba"
    }
  ];

  created() {
    this.setDatosInitSessionStorage();
    // this.$root.$on("setTitulo", (titulo: string) => { this.setTitulo(titulo) })
    // this.$root.$on("addToCart", (articulo: ARTICULO) => { this.addToCart(articulo) })
    // this.$root.$on("RestCart", (articulo: ARTICULO) => { this.RestCart(articulo) })
    // this.$root.$on("solicitarCesta", () => { this.$root.$emit("devolverCesta", this.cesta) })
    // this.$root.$on("quitarCliente", () => this.quitarCliente())
    // this.$root.$on("toggleShowCart", () => { this.showCart = true })
    this.titulo = this.tituloParam;
  }

  async mounted() {
    this.$root.$on("setTitulo", (titulo: string) => { this.setTitulo(titulo) })
    this.$root.$on("addToCart", (articulo: ARTICULO) => { this.addToCart(articulo) })
    this.$root.$on("addToCartV2", (articulo: ARTICULO) => { this.addToCartV2(articulo) })
    this.$root.$on("RestCart", (articulo: ARTICULO) => { this.RestCart(articulo) })
    this.$root.$on("solicitarCesta", () => { this.$root.$emit("devolverCesta", this.cesta) })
    this.$root.$on("quitarCliente", () => this.quitarCliente())
    this.$root.$on("toggleShowCart", () => { this.showCart = true })
    this.$root.$on("cerrarSesion", () => { this.dialogCloseSession() })
    this.$root.$on("mostrarFacturas", () => { this.MostrarFacturas() })

    this.imageUrl = await this.GetImageUrl();

    this.onChangeFiltros();
  }

  beforeDestroy() {
    this.$root.$off();

  }

  onChangeSearch() {
    this.$root.$emit("actualizarBuscador", this.search);
  }

  onClickRefresh() {
    this.$root.$emit("refresh");
  }

  onChangeFecha() {
    this.menuDate = false;
  }

  limpiarFiltros() {
    this.dates = [
      this.formatDateEN(new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toLocaleDateString()),
      this.formatDateEN(new Date(Date.now()).toLocaleDateString())
    ];
    this.search = "";
    this.proveedor = "";
    this.situacion = "";
    this.onChangeSearch();
    this.onChangeFiltros();
  }

  onChangeFiltros() {
    this.dialogFiltros = false;
    const tmpFiltros: FiltrosType = {
      dates: this.dates,
      proveedor: this.proveedor,
      situacion: this.situacion
    }
    this.setDatosSessionStorage();
    this.$root.$emit("actualizarFiltros", tmpFiltros);
  }

  setDatosInitSessionStorage() {

    if (localStorage.getItem("cesta") != null) this.getCartSessionStorage(JSON.parse(localStorage.getItem("cesta")));
    const rutaActual = this.$router.currentRoute.name;
    const tmpFiltros: FiltrosType = {
      dates: this.dates,
      proveedor: this.proveedor,
      situacion: this.situacion
    };

    switch (rutaActual) {
      case "ListadoCompras":
        if (this.$session.exists("ListadoCompras")) {
          this.getFiltrosSessionStorage(JSON.parse(this.$session.get("ListadoCompras")));
        } else {
          tmpFiltros.dates = [
            this.formatDateEN(new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toLocaleDateString()),
            this.formatDateEN(new Date(Date.now()).toLocaleDateString())
          ];
          this.setFiltrosSessionStorage(rutaActual, tmpFiltros);
          this.getFiltrosSessionStorage(tmpFiltros);
          this.onChangeFiltros();
        }
        break;
    }
  }

  setDatosSessionStorage() {
    const rutaActual = this.$router.currentRoute.name;
    const tmpFiltros: FiltrosType = {
      dates: this.dates,
      proveedor: this.proveedor,
      situacion: this.situacion
    };

    switch (rutaActual) {
      case "ListadoCompras":
        this.setFiltrosSessionStorage(rutaActual, tmpFiltros);
        break;
    }
  }

  setFiltrosSessionStorage(nombre: string, filtros: FiltrosType) {
    this.$session.set(nombre, JSON.stringify(filtros));
  }

  getFiltrosSessionStorage(filtros: FiltrosType) {
    this.dates = filtros.dates;
    this.proveedor = filtros.proveedor;
    this.situacion = filtros.situacion;

  }

  get computedDateFormatted() {
    this.dates.sort();
    return this.formatDateES(this.dates[0]) + " - " + this.formatDateES(this.dates[1]);
  }

  dialogCloseSession(){
    this.showClose = true;
  }

  imageError(item: any){
    item.articulo.IMAGEN = this.imageUrl + "default.jpg";
  }

  getValue(item){
    return item.cantidad;
  }

  CerrarSession() {
    this.removeCart();
    this.unsetUsuario();
    localStorage.setItem("userLogged", [])
    localStorage.removeItem("check_stock");
    this.$router.push({ name: "Login" });
  }

  quitarCliente() {
    localStorage.setItem("CliePedido", [])
  }

  setTitulo(titulo: string) {
    let tituloTmp = titulo;
    if (tituloTmp == undefined) {
      tituloTmp = "";
    }
    this.titulo = tituloTmp;
  }

  emptyCart() {
    return (this.cesta.length == 0)
  }

  getCartSessionStorage(listadoCesta: Array<CESTA>) {
    this.cesta = listadoCesta
    this.$root.$emit("devolverCesta", listadoCesta)
  }

  async addToCart(_articulo: ARTICULO) {
    this.showCart = false;

    const puedoAnadir = await this.CheckArticuloPermitido({ codart: _articulo.CODART });
    if (puedoAnadir) {
      const existe = this.cesta.find(x => x.articulo.CODART == _articulo.CODART);
      let cantidad = _articulo.UNIDADES;
      console.log("v1 "+cantidad);
      
      if (cantidad == undefined) cantidad = 1;

      if(cantidad > _articulo.STOCK){
        this.$toast.error("No se puede añadir el artículo '" + _articulo.CODART.trim() + "' a la cesta, stock insuficiente.");
      }
      else{
        if (existe == undefined && _articulo.UNIPAQV>1) {
          const _cesta: CESTA = {
            articulo: _articulo,
            cantidad: _articulo.CANTIDAD
          }
          this.cesta.push(_cesta)
          this.setCartSessionStorage(this.cesta)
        }
        else if (existe == undefined) {
          const _cesta: CESTA = {
            articulo: _articulo,
            cantidad: cantidad
          }
          this.cesta.push(_cesta)
          this.setCartSessionStorage(this.cesta)
        } else {
          this.moreQuantity(existe, cantidad)
        }
      }

    } else {
      this.$toast.error("El artículo '" + _articulo.CODART.trim() + "' está bloqueado.");
    }
  }

  async addToCartV2(_articulo: ARTICULO) {
    this.showCart = false;

    console.log(_articulo)
    const puedoAnadir = await this.CheckArticuloPermitido({ codart: _articulo.CODART });
    if (puedoAnadir) {
      const existe = this.cesta.find(x => x.articulo.CODART == _articulo.CODART);
      const cantidad = _articulo.CANTIDAD;
      if(Number(cantidad) > _articulo.STOCK){
        this.$toast.error("No se puede añadir el artículo '" + _articulo.CODART.trim() + "' a la cesta, stock insuficiente.");
      }
      else{
        console.log(cantidad+" "+existe);
        this.moreQuantityV2(existe, cantidad)
      }
    } else {
      this.$toast.error("El artículo '" + _articulo.CODART.trim() + "' está bloqueado.");
    }
  }

  RestCart(_articulo: ARTICULO) {
    this.showCart = false;


    const existe = this.cesta.find(x => x.articulo.CODART == _articulo.CODART);
    if (existe != undefined) {
      
      if(_articulo.CANTIDAD <= 0) {
        existe.cantidad = 0;
        existe.articulo.CANTIDAD = 0;
        existe.articulo.CAJAS=0;
      }

      this.lessQuantity(existe)
    }
  }

  setCartSessionStorage(listadoCesta: Array<CESTA>) {
    localStorage.setItem("cesta", JSON.stringify(listadoCesta))
    this.$root.$emit("devolverCesta", listadoCesta)
  }

  removeCart() {
    this.cesta = [];
    this.setCartSessionStorage([])
  }

  lessQuantity(item: CESTA) {
    console.log(item.cantidad - 1);
    if (item.cantidad - 1 <= 0) {
      const index = this.cesta.findIndex(x => x == item);
      item.articulo.CAJAS=0;
      item.articulo.CANTIDAD=0;
      this.cesta.splice(index, 1)

    } else {
      if (item.cantidad > 1) item.cantidad -= 1;
      item.articulo.CAJAS = Math.ceil(item.cantidad/item.articulo.UNIPAQV)
      
    }
    this.setCartSessionStorage(this.cesta)
    this.$forceUpdate();
  }

  removeFromCesta(item: CESTA){
    item.articulo.CANTIDAD=0;
    item.articulo.CAJAS=0;
    const index = this.cesta.findIndex(x => x == item);
    this.cesta.splice(index, 1)
    this.setCartSessionStorage(this.cesta)
    this.$forceUpdate();
  }

  moreQuantity(item: CESTA, cantidad?: number) {
    const lastCant = item.cantidad;
     
     
    if (typeof cantidad == 'undefined') cantidad = 1;
    item.cantidad = Number.parseInt(item.cantidad) + Number.parseInt(cantidad);
    item.articulo.CAJAS = Math.ceil(item.cantidad/item.articulo.UNIPAQV);

    if(item.cantidad > item.articulo.STOCK){
      this.$toast.error("No se puede añadir el artículo " + item.articulo.CODART.trim() + " a la cesta, stock insuficiente.");
      item.cantidad = lastCant;
    }else{
        item.articulo.CANTIDAD=item.cantidad;
        this.setCartSessionStorage(this.cesta)
    }
  }

  moreQuantityV2(item: CESTA, cantidad?: number) {
    const lastCant = item?.articulo.CANTIDAD;
    console.log(lastCant)
    console.log(cantidad);
    item.cantidad = cantidad;

    console.log(item.cantidad);

    if(item.cantidad > item.articulo.STOCK){
      this.$toast.error("No se puede añadir el artículo " + item.articulo.CODART.trim() + " a la cesta, stock insuficiente.");
      item.cantidad = lastCant;
    }else{
        this.setCartSessionStorage(this.cesta)
    }
  }

  moreQuantityV3(item: CESTA, cantidad?: number) {
    const lastCant = item.articulo.CANTIDAD;
    console.log(lastCant)
    item.cantidad = lastCant;

    console.log(item.cantidad);

    if(item.cantidad > item.articulo.STOCK){
      this.$toast.error("No se puede añadir el artículo " + item.articulo.CODART.trim() + " a la cesta, stock insuficiente.");
      item.cantidad = lastCant;
    }else{
        this.setCartSessionStorage(this.cesta)
    }
  }

  moreQuant(item: CESTA){
    if(item.cantidad == "") {
      item.cantidad = 0;
      item.articulo.CANTIDAD = 0;
    }
    item.articulo.CANTIDAD = item.cantidad
    item.articulo.CAJAS=Math.ceil(item.cantidad/item.articulo.UNIPAQV);
    if((Number(item.articulo.CANTIDAD) > item.articulo.STOCK) && item.cantidad > 0){
      this.$toast.error("La cantidad introducida no es correcta, supera el stock disponible.")
      item.articulo.CANTIDAD = item.articulo.STOCK;
      item.cantidad = item.articulo.STOCK;
      this.moreQuantityV3(item)
    }
    else{
      if(item.cantidad == 0)
        this.$root.$emit("RestCart", item.articulo);
      else{
        item.cantidad = item.articulo.CANTIDAD;
        this.moreQuantityV3(item)
      }
        
    }
  }

  cleanCart() {
    this.removeCart();
  }

  AñadirCaja(item: CESTA,qtt: number){
    if (qtt != 0) {
      item.articulo.CAJAS += qtt;
    }
    item.cantidad = item.articulo.UNIPAQV*item.articulo.CAJAS;
    if(item.cantidad<=0)this.removeFromCesta(item);
    
    
  }

  async onServirPedido() {
    this.$root.$emit("loading", true);
    const stock: string = await this.checkStock({cesta: this.cesta})
    if(stock.length == 0){
      this.$root.$emit("loading", false);
      this.$router.push({ name: "FinalizarPedido" });
    }
    else{
      this.$root.$emit("loading", false);
      this.$toast.error(stock);    
    }
  }

  get rutaEsPedidosCompletados() {
    return this.$router.currentRoute.name == "PedidoCompletados";
  }

  MostrarHistorico() {
    if (this.$router.currentRoute.name != "PedidoCompletados") this.$router.push({ name: "PedidoCompletados" });
  }

  MostrarInicio() {
    if (this.$router.currentRoute.name != "venta") this.$router.push({ name: "venta" });
  }

  MostrarFacturas() {
    if (this.$router.currentRoute.name != "FacturasPdf") this.$router.push({ name: "FacturasPdf" });
  }

  MostrarPrincipal(){
    if (this.$router.currentRoute.name != "venta") this.$router.push({ name: "venta" });
  }

  MostrarFavoritos() {
    if (this.$router.currentRoute.name != "venta") this.$router.push({ name: "venta", query: { favoritos: true } });
    else {
      let url = window.location.href;
      if (url.indexOf('?') > -1) {
        url += '&favoritos=true'
      } else {
        url += '?favoritos=true'
      }

      window.location.href = url;
    }
  }

  onVolverInicio() {
    if (this.VolverInicio) {
      
      this.$router.push({ name: "venta" });
    }
  }

  getUnidadesTotales(cesta: Array<CESTA>){
    let total = 0;
    for(let i = 0; i< cesta.length;i++)
      total += cesta[i].cantidad;

    return total;
  }

  getPrecioTotal(cesta: Array<CESTA>){
    let total = 0;
    for(let i = 0; i< cesta.length;i++)
      total += cesta[i].cantidad * cesta[i].articulo.PRCVENTA;

    return total.toFixed(2);
  }

  getPrecioTotalV2(cesta: Array<CESTA>){
    let total = 0;
    for(let i = 0; i< cesta.length;i++)
      total += cesta[i].cantidad * cesta[i].articulo.PRCVENTA;

    return total.toFixed(2);
  }
}